export type ClickableBooking = {
  id: string
  service_name?: string | null
}

export type CalendarEventClickResult<T extends ClickableBooking = ClickableBooking> =
  | { kind: "overlap_group"; bookings: T[] }
  | { kind: "open_booking"; booking: T }
  | { kind: "none" }

export function calendarEventClick<T extends ClickableBooking>(event: {
  data?: {
    event_type?: string | null
    bookings?: T[]
    id?: string
  } & Partial<T> | null
}): CalendarEventClickResult<T> {
  const data = event.data
  if (!data) return { kind: "none" }

  if (data.event_type === "overlap_group") {
    const grouped = data.bookings
    if (grouped && grouped.length > 1) {
      return { kind: "overlap_group", bookings: grouped }
    }
    if (grouped && grouped.length === 1) {
      return { kind: "open_booking", booking: grouped[0] }
    }
    return { kind: "none" }
  }

  return { kind: "open_booking", booking: data as T }
}
